import Vue from 'vue'
import { GET_PLACES, ERROR_XHR } from '../mutation-types.js'

export const getPlaces = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('place')
    .then(
      (response) => {
        dispatch(GET_PLACES, response.json())
        resolve()
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/placeActions.js